import { render, staticRenderFns } from "./CodeBlockAnchor.vue?vue&type=template&id=728ae72b&scoped=true"
import script from "./CodeBlockAnchor.vue?vue&type=script&lang=ts"
export * from "./CodeBlockAnchor.vue?vue&type=script&lang=ts"
import style0 from "./CodeBlockAnchor.vue?vue&type=style&index=0&id=728ae72b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ae72b",
  null
  
)

export default component.exports